export default function validateExamineeAdditionalInformationFieldOptionName(value?: string) {
  let error;
  return error;
}
